import { TransProp } from "@icc/shared/helpers";
import { RollerGuide } from "./guide";

/** Prowadzenia */
export class RollerGuides {
    id: number;
    /** Id żaluzji */
    shutterId: number;
    /** Lewe prowdzenie.
     *
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp()
    left: RollerGuide | null;
    /**
     * Prawe prowadzenie
     *
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp()
    right: RollerGuide | null;

    /** Prowadzenia podziałowe moskitier */
    mosquitoScreens: {
        guide: RollerGuide;
        leftMosquitoScreenId: number | null;
        rightMosquitoScreenId: number | null;
    }[];
}
